module.exports = __webpack_public_path__ + "img/wechatPub.93cb3db4.jpg";